<template>
  <div>
    <UserCreationPanel :user="description.user" :created="description.created" />

    <div class="content text-break" v-html="description.text"></div>

    <div v-if="description.canEdit || description.canDelete" class="d-flex align-items-center justify-content-between mb-10px">
      <!-- EDIT -->
      <div v-if="description.canEdit">
        <button class="btn btn-link p-0" role="button" @click="this.$emit('toggleEditMode')">
          <span>Upraviť</span>
        </button>
      </div>

      <!-- DELETE -->
      <div v-if="description.canDelete" class="ms-auto">
        <button class="btn btn-link p-0" role="button" @click="this.$emit('deleteDescription')">
          <span>Odstrániť</span>
        </button>
      </div>
    </div>

    <div class="d-flex align-items-center justify-content-between">
      <VoteWrapper :vote-property="'fk_description'" :vote-value="description.id" :can-vote="description.canVote" />

      <div v-if="description.canReport">
        <Report :entity-name="'fk_description'" :entity-id="description.id" :entity-value="'text'" />
      </div>

    </div>

    <!-- COMMENTS -->
    <div class="bg-body-gray p-10px mt-15px rounded border">
      <p class="mt-0 mb-10px">
        <strong>
          <small>Komentáre</small>
        </strong>
      </p>

      <CommentEntityWrapper
          :entity-id="description.id"
          :toggle-class="`descriptionComments${description.id}`"
          :fk_property="'description'"
          :comment-points="commentPoints"
          :slice-comments="5"
          @reload="this.$emit('reload')"
      />
    </div>
  </div>
</template>

<script>
import Report from "../Report/Report.vue";
import CommentEntityWrapper from "../Comment/CommentEntityWrapper.vue";
import UserCreationPanel from "../User/UserCreationPanel.vue";
import VoteWrapper from "../Vote/VoteWrapper.vue";

export default {
  name: "Description",
  components: { VoteWrapper, Report, CommentEntityWrapper, UserCreationPanel },
  emits: ['toggleEditMode', 'deleteDescription', 'reload'],
  props: {
    description: {
      type: Object,
      required: true,
    },
    commentPoints: Number,
  },
}
</script>
